<template>
  <div class="audit-wrap">
    <img class="audit-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211013/445a8a9c2ce41c9c66c3939ae5351df5.svg" alt="">
    <div class="title">该答题内容审核中...</div>
    <div class="desc">答题内容含有敏感词，须审核通过后才能正常使用该答题，若1个工作日后仍显示审核中，请<span @click="handleContact()">联系客服</span>协助处理。</div>
    <div class="btn" @click="handleContact()"><img src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20211231/ebb36eba163d4398ca25469424f47bdb.png" alt="">点我进入极速审核</div>
    <ContactImg :visible="showContact" @hideVisible="handleContact()" />

  </div>
</template>
<script>
import ContactImg from "@/components/contactImg";
import { showServiceAble } from "@/utils/common";

export default {
  data() {
    return{
      showContact: false
    }
  },
  methods: {
    async handleContact() {
      let res = await showServiceAble();
      if(res) {
        this.showContact = !this.showContact;
      }
    }
  },
  components: {ContactImg}
};
</script>

<style lang="scss" scoped>
  @function rem($px) {
    @return $px / 75 + rem;
  }
  .audit-wrap{
    text-align: center;
    font-size: rem(28);
    padding: rem(80) rem(75) 0;
    box-sizing: border-box;
    background: #ffffff;
  }
  .audit-icon {
    width: rem(140);
    height: rem(140);
  }
  .title {
    color: #000000;
    font-size: rem(36);
    margin: rem(40) 0 rem(30);
    line-height: rem(54);
  }
  .desc{
    color: #999;
    line-height: rem(42);
    text-align: left;
    span{
      color: #1890ff;
      text-decoration: underline;
    }
  }
  .btn {
    height: rem(70);
    background: #1890ff;
    color: #ffffff;
    border-radius: rem(4);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: rem(60);
    img{
      width: rem(60);
      height: rem(60);
      margin-top: rem(8);
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/normal/audit.vue